export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/testsFill.94a5ce77.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};